module.exports = __webpack_public_path__ + "img/Scanvaegt3.68dd766b.png";